import React, { Fragment, Component } from 'react';
import BusinessSettingList from './components/BusinessSettingList';

export default class BusinessSettings extends Component {
    render() {
        return (
            <Fragment>
                <BusinessSettingList />
            </Fragment>
        );
    }
}